import { FormLayout } from "@shopify/polaris"
import { Option, ProSpinner } from "polaris-enhance"

import { ProSchemaItem } from "./ProSchemaItem"

export interface SchemaItem {
  id?: string
  label: string
  key: string
  component:
    | "ProTextField"
    | "ProTextFieldPrice"
    | "ProTextFieldWithPassword"
    | "ProSelect"
  placeholder?: string
  options?: Option[]
  helpText?: string
  required?: boolean
  prefix?: string
  maxLength?: number
  showCharacterCount?: boolean
  active?: boolean
}

export type Schemas = SchemaItem[]

interface ProSchemaFormProps<T = any> {
  schemas: Schemas
  // 表单
  value: T
  // 设置表单
  onChange: (value: T) => void
  loading?: boolean
}
function ProSchemaForm<T>(props: ProSchemaFormProps<T>) {
  const { schemas, value, onChange, loading = false } = props

  return (
    <ProSpinner loading={loading}>
      <FormLayout>
        {schemas.map((item) => {
          return (
            <ProSchemaItem
              id={item.id}
              key={item.key}
              type={item.component}
              label={item.label}
              options={item.options}
              value={value[item.key]}
              placeholder={item.placeholder}
              required={item.required}
              helpText={item.helpText}
              prefix={item.prefix}
              maxLength={item.maxLength}
              showCharacterCount={item.showCharacterCount}
              rules={item.rules}
              onChange={(val) => {
                onChange({ ...value, [item.key]: val })
              }}
            />
          )
        })}
      </FormLayout>
    </ProSpinner>
  )
}
export default ProSchemaForm
